module.exports = __webpack_public_path__ + "img/month_6_icon.51323d80.png";